/**
 * @format
 * @module lib/financial/stockcalc-report
 */
import { toArray } from "utils/utils";
import { isSubscribed, isOnDemand, isFinancialToolsTrial } from "lib/identity/api";
import { constructQuery } from "utils/urls";
import { AWS_STOCKCALC } from "lib/amazon-web-services";

/**
 * @method init
 * @description initializes the "StockCalc Reports" card and download link
 */
export default function init() {
  if (isSubscribed() || isOnDemand() || isFinancialToolsTrial()) {
    const links = toArray(document.querySelectorAll(".js-stockcalc-link"));
    links.forEach(link => {
      const query = constructQuery(
        {
          symbol: encodeURIComponent(link.dataset.symbol || "")
        },
        true
      );
      link.setAttribute("href", AWS_STOCKCALC + "?" + query);
    });
  }
}
